import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../config/config"; // ← same config as TopBar
import { ArrowLeftRight, X, ChevronRight } from "lucide-react";

const GOLDd = "#222";

export default function FeeTransfer() {
  const [userRole, setUserRole] = useState("clerk"); // you can pull this from auth / TopBar later
  const [students, setStudents] = useState([]);
  const [loadingStudents, setLoadingStudents] = useState(true);
  const [data, setData] = useState([]);
  const [fromStudent, setFromStudent] = useState("");
  const [toStudent, setToStudent] = useState("");
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");
  const [step, setStep] = useState("form");
  const [pendingTransfers, setPendingTransfers] = useState([]); // you can fetch these later
  const [activeTab, setActiveTab] = useState("transfer");
  const [notification, setNotification] = useState(null);

  // ── Fetch students same way as TopBar ──
  const fetchStudents = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      setLoadingStudents(true);
      const res = await axios.get(`${config.API_URL}/api/pullstudents`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setStudents(res.data.students || []);
    } catch (err) {
      console.error("Error fetching students:", err);
      showNotif("Failed to load students", "error");
    } finally {
      setLoadingStudents(false);
    }
  };

   const fetchTransfers = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      setLoadingStudents(true);
      const res = await axios.get(`${config.API_URL}/api/pull_transfers`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setPendingTransfers(res.data.transfers || []);
    } catch (err) {
      console.error("Error fetching students:", err);
      showNotif("Failed to load students", "error");
    } finally {
      setLoadingStudents(false);
    }
  };


  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES',
    }).format(Math.abs(amount));
  };
 const pullPayments = async (id) => {
    const token = localStorage.getItem("token");
   // alert(id);
    if (!token) return;

   try {
      const res = await axios.get(config.API_URL+'/api/pullpayments2/'+id, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
         
        },
      });

      setData(res.data.data);
     // setTotal(res.data.total);
    } catch (err) {
      console.error('Error fetching invoices:', err);
    } finally {
     // setLoading(false);
    }
  };


  useEffect(() => {
    fetchStudents();
    fetchTransfers();
  }, []);

  const showNotif = (msg, type = "success") => {
    setNotification({ msg, type });
    setTimeout(() => setNotification(null), 3500);
  };

  const fromStudentData = students.find((s) => s.id === fromStudent);
  const toStudentData = students.find((s) => s.id === toStudent);
  const parsedAmount = parseFloat(amount) || 0;

  const canSubmit =
    fromStudent &&
    toStudent &&
    fromStudent !== toStudent &&
    reason.trim().length >= 5;

  // ── Submit logic ──
  const handleSubmit = async () => {
    const payload = {
      from_student_id: fromStudent,
      to_student_id: toStudent,
      amount: parsedAmount,
      reason: reason.trim(),
      // notes: "",           // add if needed
      // term_id: "...",      // optional
    };

    const token = localStorage.getItem("token");
    if (!token) {
      showNotif("No authentication token found", "error");
      return;
    }

    try {
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];


      if (!xsrfToken) throw new Error("CSRF token not found");

      // 2. POST request
      const endpoint =
        userRole === "admin"
          ? "/api/fee-transfers/request"     // direct process
          : "/api/fee-transfers/request";    // pending approval

      await axios.post(`${config.API_URL}${endpoint}`, payload, {
         headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-XSRF-TOKEN": decodeURIComponent(xsrfToken || ''),
          },
          withCredentials: true,
      });

      showNotif(
        userRole === "admin"
          ? "Transfer processed successfully."
          : "Transfer request submitted for approval."
      );

      resetForm();

    } catch (error) {
      console.error("Transfer error:", error);
      showNotif(
        error.response?.data?.message ||
        "Failed to submit transfer. Please try again.",
        "error"
      );
    }
  };

  const resetForm = () => {
    setFromStudent("");
    setToStudent("");
    setAmount("");
    setReason("");
    setStep("form");
  };

  const handleApprove = async (id) => {
     const payload = {
      id: id,
      // notes: "",           // add if needed
      // term_id: "...",      // optional
    };
    // TODO: call API to approve
   
    const token = localStorage.getItem("token");
    if (!token) {
      showNotif("No authentication token found", "error");
      return;
    }
    try {
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];


      if (!xsrfToken) throw new Error("CSRF token not found");

      // 2. POST request
      const endpoint =
        userRole === "admin"
          ? "/api/fee-transfers/process"     // direct process
          : "/api/fee-transfers/process";    // pending approval

      await axios.post(`${config.API_URL}${endpoint}`, payload, {
         headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-XSRF-TOKEN": decodeURIComponent(xsrfToken || ''),
          },
          withCredentials: true,
      });

      showNotif(
        userRole === "admin"
          ? "Transfer processed successfully."
          : "Transfer request submitted for approval."
      );

       setPendingTransfers((prev) => prev.filter((t) => t.id !== id));
    showNotif(`Transfer ${id} approved and processed.`);

      resetForm();

    } catch (error) {
      console.error("Transfer error:", error);
      showNotif(
        error.response?.data?.message ||
        "Failed to submit transfer. Please try again.",
        "error"
      );
    }

  };

  const handleReject = (id) => {
    // TODO: call API to reject
    setPendingTransfers((prev) => prev.filter((t) => t.id !== id));
    showNotif(`Transfer ${id} rejected.`, "error");
  };

  const getStudentName = (id) =>
    students.find((s) => s.id === id)?.name ?? id;

  if (loadingStudents) {
    return (
      <div style={{ padding: "80px", textAlign: "center", color: "#222" }}>
        Loading students...
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#ffffff",
       
        color: "#1a1a1a",
      }}
    >
      <div style={{ maxWidth: "80%", margin: "0 auto", padding: "48px 24px" }}>
        {/* Header */}
        <div style={{ marginBottom: 40 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <div>
              <p
                style={{
                  color: GOLDd,
                  letterSpacing: "0.25em",
                  fontSize: 11,
                  textTransform: "uppercase",
                  margin: "0 0 8px",
                }}
              >
               
              </p>
              <h1
                style={{
                  fontSize: 34,
                  fontWeight: 400,
                  margin: 0,
                  lineHeight: 1.15,
                  letterSpacing: "-0.02em",
                  color: "#1a1a1a",
                }}
              >
                Fee Transfer <span style={{ color: GOLDd }}></span>
              </h1>
            </div>
            <div style={{ textAlign: "right" }}>
              <p
                style={{
                  fontSize: 11,
                  color: "#bbb",
                  margin: "0 0 6px",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                }}
              >
                Role
              </p>
              <div style={{ display: "flex", gap: 4 }}>
                {["clerk", "admin"].map((role) => (
                  <button
                    key={role}
                    onClick={() => {
                      setUserRole(role);
                      setActiveTab("transfer");
                      resetForm();
                    }}
                    style={{
                      padding: "6px 18px",
                      borderRadius: 4,
                      border: "1px solid",
                      borderColor: userRole === role ? GOLDd : "#ddd",
                      background: userRole === role ? GOLDd : "#fff",
                      color: userRole === role ? "#fff" : "#aaa",
                      cursor: "pointer",
                      fontSize: 12,
                      fontFamily: "inherit",
                      textTransform: "capitalize",
                      transition: "all 0.2s",
                    }}
                  >
                    {role}
                  </button>
                ))}
              </div>
            </div>
          </div>
          <div
            style={{
              height: 1,
              background: `linear-gradient(90deg, ${GOLDd} 0%, ${GOLDd}44 60%, transparent 100%)`,
              marginTop: 24,
            }}
          />
        </div>

        {/* Notification */}
        {notification && (
          <div
            style={{
              padding: "12px 18px",
              borderRadius: 6,
              marginBottom: 24,
              border: "1px solid",
              borderColor:
                notification.type === "error" ? "#e74c3c" : "#27ae60",
              background:
                notification.type === "error" ? "#fff5f5" : "#f0faf4",
              color: notification.type === "error" ? "#c0392b" : "#1e8449",
              fontSize: 14,
              animation: "fadeIn 0.3s ease",
            }}
          >
            {notification.type === "success" ? "✓" : "✗"} {notification.msg}
          </div>
        )}

        {/* Tabs — admin only */}
        {userRole === "admin" && (
          <div
            style={{
              display: "flex",
              marginBottom: 32,
              borderBottom: "1px solid #ececec",
            }}
          >
            {[
              { id: "transfer", label: "New Transfer" },
              {
                id: "approvals",
                label: `Pending Approvals${
                  pendingTransfers.length > 0
                    ? ` (${pendingTransfers.length})`
                    : ""
                }`,
              },
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => {
                  setActiveTab(tab.id);
                  setStep("form");
                }}
                style={{
                  padding: "12px 24px",
                  background: "transparent",
                  border: "none",
                  borderBottom: `2px solid ${
                    activeTab === tab.id ? GOLDd : "transparent"
                  }`,
                  color: activeTab === tab.id ? GOLDd : "#aaa",
                  cursor: "pointer",
                  fontFamily: "inherit",
                  fontSize: 14,
                  letterSpacing: "0.04em",
                  transition: "all 0.2s",
                  marginBottom: -1,
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}

        {/* FORM */}
        {activeTab === "transfer" && step === "form" && (
          <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 40px 1fr",
                gap: 12,
                alignItems: "start",
              }}
            >
              <div>
                <label style={labelStyle}>Transfer From</label>
                <select
                  value={fromStudent}
                  onChange={(e) => {setFromStudent(e.target.value); pullPayments(e.target.value)}}
                  style={selectStyle}
                >
                  <option value="">Select student…</option>
                  {students.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.name} — {s.id}
                    </option>
                  ))}
                </select>
                {fromStudentData && (
                  <p
                    style={{
                      margin: "6px 0 0",
                      fontSize: 12,
                      color: "#999",
                    }}
                  >
                    Balance:{" "}
                    <span style={{ color: GOLDd, fontWeight: 600 }}>
                      KES {fromStudentData.balance?.toFixed(2) ?? "—"}
                    </span>{" "}
                    · {fromStudentData.grade ?? "—"}
                  </p>
                )}
              </div>

              <div
                style={{
                  textAlign: "center",
                  fontSize: 20,
                  color: GOLDd,
                  paddingTop: 34,
                }}
              >
                →
              </div>

              <div>
                <label style={labelStyle}>Transfer To</label>
                <select
                  value={toStudent}
                  onChange={(e) => setToStudent(e.target.value)}
                  style={selectStyle}
                >
                  <option value="">Select student…</option>
                  {students
                    .filter((s) => s.id !== fromStudent)
                    .map((s) => (
                      <option key={s.id} value={s.id}>
                        {s.name} — {s.id}
                      </option>
                    ))}
                </select>
                {toStudentData && (
                  <p
                    style={{
                      margin: "6px 0 0",
                      fontSize: 12,
                      color: "#999",
                    }}
                  >
                    Balance:{" "}
                    <span style={{ color: GOLDd, fontWeight: 600 }}>
                      KES {toStudentData.balance?.toFixed(2) ?? "—"}
                    </span>{" "}
                    · {toStudentData.grade ?? "—"}
                  </p>
                )}
              </div>
            </div>

            <div>
                <label style={labelStyle}>Select Payment</label>
                <select
                  value={amount}
                  onChange={(e) => {setAmount(e.target.value);}}
                  style={selectStyle}
                >
                  <option value="">…</option>
                  {data.map((s) => (
                    <option key={s.id} value={s.id}>
                      {s.payment_reference} — {s.amount} - Paid On {s.created_at}
                    </option>
                  ))}
                </select>
              
              </div>

            <div>
              <label style={labelStyle}>Reason for Transfer</label>
              <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Describe why the fee is being transferred…"
                rows={3}
                style={{
                  ...inputStyle,
                  width: "100%",
                  resize: "vertical",
                  minHeight: 80,
                }}
              />
            </div>

            {userRole === "clerk" && (
              <div
                style={{
                  padding: "12px 16px",
                  background: "#fffbf0",
                  border: `1px solid ${GOLDd}55`,
                  borderRadius: 6,
                  fontSize: 13,
                  color: "#7a5c0a",
                }}
              >
                Your request will be submitted for admin approval before processing.
              </div>
            )}

            <div>
              <button
                disabled={!canSubmit}
                onClick={handleSubmit}
                style={{
                  padding: "13px 32px",
                  background: canSubmit ? GOLDd : "#f2f2f2",
                  color: canSubmit ? "#fff" : "#bbb",
                  border: "none",
                  borderRadius: 6,
                  cursor: canSubmit ? "pointer" : "not-allowed",
                  fontFamily: "inherit",
                  fontSize: 15,
                  letterSpacing: "0.04em",
                  fontWeight: 600,
                  transition: "all 0.2s",
                }}
              >
                {userRole === "admin"
                  ? "Confirm & Process Transfer"
                  : "Submit for Approval"}
              </button>
            </div>
          </div>
        )}

           {activeTab === "transfer" && step === "success" && (
          <div style={{ textAlign: "center", padding: "56px 0" }}>
            <div style={{
              width: 64, height: 64, borderRadius: "50%", background: "#edfaf3",
              border: "2px solid #27ae60", display: "flex", alignItems: "center",
              justifyContent: "center", margin: "0 auto 20px", fontSize: 26, color: "#27ae60"
            }}>✓</div>
            <h2 style={{ fontSize: 28, fontWeight: 400, margin: "0 0 12px", color: "#1a1a1a" }}>Transfer Processed</h2>
            <p style={{ color: "#555", margin: "0 0 6px", fontSize: 15 }}>
              R {parsedAmount.toFixed(2)} transferred from <strong>{fromStudentData?.name}</strong> to <strong>{toStudentData?.name}</strong>
            </p>
            <p style={{ color: "#bbb", fontSize: 13, margin: "0 0 40px" }}>
              {new Date().toLocaleDateString("en-ZA", { day: "numeric", month: "long", year: "numeric" })}
            </p>
            <button onClick={resetForm} style={{
              padding: "12px 28px", background: GOLDd, color: "#fff",
              border: "none", borderRadius: 6, cursor: "pointer",
              fontFamily: "inherit", fontSize: 14, fontWeight: 600, letterSpacing: "0.04em",
            }}>New Transfer</button>
          </div>
        )}

         {activeTab === "approvals" && userRole === "admin" && (
          <div>
            <p style={{ color: "#aaa", fontSize: 14, marginBottom: 24 }}>
              {pendingTransfers.length === 0
                ? "No pending transfer requests."
                : `${pendingTransfers.length} transfer${pendingTransfers.length > 1 ? "s" : ""} awaiting your approval.`}
            </p>
            {pendingTransfers.map(t => (

              <div key={t.id} style={{ background: "#fafafa", border: "1px solid #e8e8e8", borderRadius: 8, padding: 24, marginBottom: 16 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
                  <div>
                    <span style={{ fontSize: 11, color: GOLDd, letterSpacing: "0.15em", textTransform: "uppercase", fontWeight: 600 }}>{t.id}</span>
                    <p style={{ margin: "4px 0 0", fontSize: 13, color: "#bbb" }}>
                      Requested by <strong style={{ color: "#222" }}>{t.requestedBy}</strong> · {t.date}
                    </p>
                  </div>
                  <span style={{ fontSize: 22, color: GOLDd, fontWeight: 600 }}> {formatCurrency(t.amount)}</span>
                </div>
                <div style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 10 }}>
                  <span style={{ color: "#1a1a1a", fontSize: 15 }}>{getStudentName(t.from)}</span>
                  <span style={{ color: GOLDd }}>→</span>
                  <span style={{ color: "#1a1a1a", fontSize: 15 }}>{getStudentName(t.to)}</span>
                </div>
                <p style={{ margin: "0 0 20px", color: "#999", fontSize: 13, fontStyle: "italic" }}>"{t.reason}"</p>

                
                
                <div style={{ display: "flex", gap: 10 }}>
                  <button onClick={() => handleApprove(t.id)} style={{
                    padding: "9px 22px", background: "#edfaf3", color: "#1e8449",
                    border: "1px solid #a9dfbf", borderRadius: 5, cursor: "pointer",
                    fontFamily: "inherit", fontSize: 13, transition: "all 0.2s",
                  }}>✓ Approve</button>
                  <button onClick={() => handleReject(t.id)} style={{
                    padding: "9px 22px", background: "#fff5f5", color: "#c0392b",
                    border: "1px solid #f5c6c0", borderRadius: 5, cursor: "pointer",
                    fontFamily: "inherit", fontSize: 13, transition: "all 0.2s",
                  }}>✗ Reject</button>
                </div>
              </div>
            ))}
          </div>
        )}
        {/* ... paste your confirm, success, approvals JSX here if you want to keep them ... */}

        {/* Footer */}
        <div style={{ marginTop: 56, height: 1, background: "#ececec" }} />
        <p
          style={{
            color: "#ccc",
            fontSize: 11,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            marginTop: 14,
          }}
        >
          Logged in as:{" "}
          <span style={{ color: userRole === "admin" ? GOLDd : "#bbb" }}>
            {userRole.toUpperCase()}
          </span>{" "}
          — All transfers are logged for audit purposes
        </p>
      </div>

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(-4px); } to { opacity: 1; transform: translateY(0); } }
        input:focus, textarea:focus, select:focus { border-color: #b8860b !important; outline: none; box-shadow: 0 0 0 3px #b8860b18; }
        select option { background: #fff; color: #1a1a1a; }
      `}</style>
    </div>
  );
}

const labelStyle = {
  display: "block",
  fontSize: 11,
  color: "#aaa",
  letterSpacing: "0.15em",
  textTransform: "uppercase",
  marginBottom: 8,
};

const inputStyle = {
  padding: "11px 13px",
  background: "#fff",
  border: "1px solid #ddd",
  borderRadius: 6,
  color: "#1a1a1a",
  fontFamily: "inherit",
  fontSize: 15,
  outline: "none",
  boxSizing: "border-box",
  transition: "border-color 0.2s, box-shadow 0.2s",
};

const selectStyle = {
  ...inputStyle,
  width: "100%",
  cursor: "pointer",
  appearance: "none",
  backgroundImage:
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23bbb' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E\")",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "calc(100% - 14px) center",
  backgroundSize: "12px",
  paddingRight: 36,
};